"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonScheduleInfo = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
const core_1 = require("@veeam/core");
const ScheduleInfoDataRow_1 = require("../ScheduleInfoDataRow");
require("./types");
const WIDTH = '160px';
const LabelWrapper = styled_components_1.default.div `
  width: ${WIDTH};
`;
const CommonScheduleInfo = ({ iconSrc, scheduleEnabledField, isToggleDisabled, isLoading, onShowPanel, toggleLabel, toggleTitleOff, toggleTitleOn, items, showPanelBtnLabel, }) => {
    const { control: { value: isEnabled }, } = core_1.useField(scheduleEnabledField);
    return (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, gap: components_1.STACK_GAP.m },
        react_1.default.createElement(components_1.FormLayout, { inlineLabel: true },
            react_1.default.createElement(components_1.Separator, null),
            react_1.default.createElement(components_1.ToggleField, { label: react_1.default.createElement(LabelWrapper, null, toggleLabel), field: scheduleEnabledField, disabled: isToggleDisabled || isLoading, showSuffix: true, titles: {
                    on: toggleTitleOn,
                    off: toggleTitleOff,
                } })),
        isEnabled && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, gap: components_1.STACK_GAP.xs }, items.map(({ label, value, tooltipData }) => (react_1.default.createElement(ScheduleInfoDataRow_1.ScheduleInfoDataRow, { key: label, label: label, value: value, labelWidth: WIDTH, tooltipData: tooltipData })))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(components_1.Button, { ui: components_1.BUTTON_VIEW.text, disabled: isLoading, onClick: onShowPanel },
                    react_1.default.createElement(components_1.Icon, { src: iconSrc }),
                    showPanelBtnLabel))))));
};
exports.CommonScheduleInfo = CommonScheduleInfo;
//# sourceMappingURL=CommonScheduleInfo.js.map